import type { ReactNode } from "react";
import { PageTransition } from "@/components/motion";

/**
 * A template (unlike a layout) re-mounts on every navigation, so the page
 * content plays its entrance transition on each route change. No global
 * preloader — the chrome (header/footer) persists; only page content animates.
 */
export default function MarketingTemplate({ children }: { children: ReactNode }) {
  return <PageTransition>{children}</PageTransition>;
}
